import type { SupportAssignee, SupportIssue } from '../types/supportIssue';

export const mockSupportAssignees: SupportAssignee[] = [
  {
    email: 'prasad@rjatechnologies.com',
    display_name: 'Prasad Chalasani',
    github_login: 'pchalasani',
  },
  {
    email: 'chetan@rjatechnologies.com',
    display_name: 'Chetan',
    github_login: 'rja2024',
  },
  {
    email: 'son@rjatechnologies.com',
    display_name: 'Son',
    github_login: 'sondamrja',
  },
];

export const mockSupportIssues: SupportIssue[] = [
  {
    id: 'demo-feedback-2',
    title: 'Document export loses numbered-list indentation',
    message:
      'The numbered sections look correct in Waypoint, but the exported ' +
      'document moves the second-level items to the left margin.',
    workflow: 'Market Research',
    stage: 'Section C',
    status: 'in_progress',
    created_at: '2026-08-04T15:20:00Z',
    acknowledged_at: '2026-08-04T18:05:00Z',
    completed_at: null,
    updated_at: '2026-08-07T20:15:00Z',
    customer_update_version: 2,
    has_unread_update: true,
    priority: 'high',
    backlog: false,
    owner: 'Morgan Lee',
    planned_start: '2026-08-08',
    target_completion: '2026-08-14',
    customer_updates: [
      {
        id: 'demo-update-2',
        message:
          '**Update:** We reproduced the formatting problem and are ' +
          'testing the correction in document exports.',
        published_at: '2026-08-07T20:15:00Z',
        updated_at: '2026-08-07T20:15:00Z',
      },
      {
        id: 'demo-update-1',
        message:
          'We received the example document and confirmed that the second-level ' +
          'numbering shifts during export.',
        published_at: '2026-08-05T14:20:00Z',
        updated_at: '2026-08-05T14:20:00Z',
      },
    ],
    customer_comments: [],
    user_email: 'synthetic-export@preview.invalid',
    user_unit: '52 CONS',
    github_issue_number: 248,
    github_issue_url:
      'https://github.com/RJAtechnologies/waypointprojectmgmt/issues/248',
    github_sync_state: 'sent',
  },
  {
    id: 'demo-feedback-1',
    title: 'Vendor table does not load after choosing a PSC',
    message:
      'The loading indicator stays on the vendor table after I select PSC ' +
      'code 5961 and start the search.',
    workflow: 'Market Research',
    stage: 'Vendor Discovery',
    status: 'acknowledged',
    created_at: '2026-08-06T13:10:00Z',
    acknowledged_at: '2026-08-06T17:35:00Z',
    completed_at: null,
    updated_at: '2026-08-06T17:35:00Z',
    customer_update_version: 0,
    has_unread_update: false,
    priority: 'normal',
    backlog: false,
    owner: null,
    planned_start: null,
    target_completion: null,
    customer_updates: [],
    customer_comments: [],
    user_email: 'synthetic-vendor@preview.invalid',
    user_unit: '355 WG',
    github_issue_number: 247,
    github_issue_url:
      'https://github.com/RJAtechnologies/waypointprojectmgmt/issues/247',
    github_sync_state: 'sent',
  },
  {
    id: 'demo-feedback-3',
    title: 'Let me save a vendor search for later',
    message:
      'I often compare the same vendor search over several days. I would like ' +
      'to save the filters and return to the same results without entering ' +
      'everything again.',
    workflow: 'Market Research',
    stage: 'Vendor Discovery',
    status: 'received',
    created_at: '2026-08-08T14:35:00Z',
    acknowledged_at: null,
    completed_at: null,
    updated_at: '2026-08-08T14:35:00Z',
    customer_update_version: 0,
    has_unread_update: false,
    priority: 'low',
    backlog: true,
    owner: null,
    planned_start: null,
    target_completion: null,
    customer_updates: [],
    customer_comments: [],
    user_email: 'synthetic-feature@preview.invalid',
    user_unit: '366 FW',
    github_issue_number: 249,
    github_issue_url:
      'https://github.com/RJAtechnologies/waypointprojectmgmt/issues/249',
    github_sync_state: 'sent',
  },
  {
    id: 'demo-feedback-4',
    title: 'Saved workflow opened with the wrong section selected',
    message:
      'When I reopened my construction workflow, Waypoint showed Section B ' +
      'even though I had saved my work while editing Section C.',
    workflow: 'Construction',
    stage: 'Section C',
    status: 'completed',
    created_at: '2026-07-29T16:10:00Z',
    acknowledged_at: '2026-07-29T18:00:00Z',
    completed_at: '2026-08-03T19:45:00Z',
    updated_at: '2026-08-03T19:45:00Z',
    customer_update_version: 2,
    has_unread_update: true,
    priority: 'urgent',
    backlog: false,
    owner: 'chetan@rjatechnologies.com',
    planned_start: '2026-07-30',
    target_completion: '2026-08-03',
    customer_updates: [
      {
        id: 'demo-resolution-1',
        message:
          'We fixed the workflow restore behavior. The page was using the ' +
          'first available section instead of the section saved with the ' +
          'workflow. Reopen the workflow and it will now return to Section C.',
        published_at: '2026-08-03T19:45:00Z',
        updated_at: '2026-08-03T19:45:00Z',
      },
      {
        id: 'demo-resolution-progress',
        message:
          'We reproduced the problem and are checking every workflow type ' +
          'before publishing the correction.',
        published_at: '2026-07-31T15:30:00Z',
        updated_at: '2026-07-31T15:30:00Z',
      },
    ],
    customer_comments: [],
    user_email: 'synthetic-restore@preview.invalid',
    user_unit: '673 ABW',
    github_issue_number: 250,
    github_issue_url:
      'https://github.com/RJAtechnologies/waypointprojectmgmt/issues/250',
    github_sync_state: 'sent',
  },
];
